import { Center } from '@unistocks/components/layout/center';
import { Loader } from '@unistocks/components/loading/spinner/loader';
import { Logo, LogoProps } from '@unistocks/components/logo/logo';
import { ProgressBar } from '@unistocks/components/progress-bar/progress-bar';
import { isNumber } from '@unistocks/shared/utils/util';
import { PropsWithChildren, useEffect } from 'react';
import { useSharedValue, withRepeat, withTiming } from 'react-native-reanimated';
import { useWindowDimensions } from 'tamagui';

export type AppLoaderProps = PropsWithChildren &
  LogoProps & {
    text?: string;
    loadingIndicator?: boolean;
    loadingProgress?: number;
  };

export const AppLoader: React.FC<AppLoaderProps> = ({
  text: loadingText,
  loadingIndicator = true,
  loadingProgress,
  ...logoProps
}) => {
  const { width } = useWindowDimensions();
  const DURATION = width * 5.5;
  const PROGRESS_WIDTH = width / 2;
  const HIDDEN = -(width / 2 + PROGRESS_WIDTH / 2);
  const translateX = useSharedValue(HIDDEN);

  useEffect(() => {
    translateX.value = withRepeat(withTiming(width, { duration: DURATION }), -1);
  }, [DURATION, translateX, width]);

  return (
    <Center mx={'$5'}>
      <Logo
        w={'100%'}
        h={'auto'}
        my={'$3'}
        overflow="hidden"
        pressStyle={{ opacity: 1 }}
        $sm={{
          maxWidth: 400
        }}
        {...logoProps}
      />

      {isNumber(loadingProgress) ? (
        <ProgressBar
          transition={'quicker'}
          value={loadingProgress}
          mt={loadingText ? '$2' : undefined}
        />
      ) : loadingIndicator ? (
        <Loader size={'$8'} flexGrow={0}>
          {loadingText}
        </Loader>
      ) : null}
    </Center>
  );
};

AppLoader.displayName = 'AppLoader';
